var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"demo-section",attrs:{"id":"lc-progress"}},[_c('h2',{staticClass:"demo-section__title",attrs:{"id":"lc-loading-indicator"}},[_vm._v("<lc-loading-indicator/>")]),_c('lc-loading-indicator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }